import RestaurantCardTitleRow from './titleRow';

export { type RestaurantCardTitleRowProps } from './titleRow';

export default RestaurantCardTitleRow;

export { default as RestaurantCardTitleRowSkeleton } from './skeleton';
